const AesPartyScreeningApiUrls = {
  SEARCH_PARTY_SCREENING: `${process.env.REACT_APP_USER_AES_URL}/aes/shipment/searchPartyScreening`,
};

export default AesPartyScreeningApiUrls
